export type Locales = keyof LanguageTranslation;

export class LanguageTranslation {
  en?: string | null;
  fr?: string | null;
}

export interface DTOLanguageEnabled {
  language_enabled: Locales[];
}

export interface LanguageEnabled {
  languageEnabled: Locales[];
}
